<template>
  <v-select
    :model-value="value || null"
    :items="levels"
    :placeholder="placeholder"
    :disabled="isReadOnly"
    :clearable="!isReadOnly"
    item-value="ulid"
    item-title="display_name"
    variant="plain"
    density="compact"
    hide-details
    class="job-level-editor"
    :list-props="{ density: 'compact', nav: true }"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useAppAuthData } from '@/stores/app/authData';

defineProps({
  value: { type: String, default: null },
  placeholder: { type: String, default: 'Level' },
  isReadOnly: { type: Boolean, default: false },
});

defineEmits(['update:modelValue']);

const { authData } = storeToRefs(useAppAuthData());
const levels = computed(() => authData.value.jobProfileLevels ?? []);
</script>

<style scoped lang="less">
.job-level-editor {
  :deep(.v-input__control) {
    .v-field__input {
      padding: 0;
      min-height: unset;
      font-size: 12px;
      line-height: 16px;
      opacity: 1;
    }
    .v-field__clearable, .v-field__append-inner {
      height: 16px;
      width: 12px;
      padding-top: 2px;
      svg {
        width: 12px;
        height: 12px;
        min-width: 12px;
      }
    }
  }
}
</style>
